<template>
    <v-dialog v-model="dialog" width="1200" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-card title="Basic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="fname"
                                                label="First Name"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="mname"
                                                label="Middle Name"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="4">
                                            <v-text-field
                                                v-model="lname"
                                                label="Last Name"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="suffix"
                                                label="Suffix"
                                                hint="Ex: Jr or Sr,"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                                </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="post_nominal"
                                                label="Post Nominal"
                                                hint="Ex: Ph.D, MIT"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                                </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-textarea
                                                v-model="undergraduate"
                                                label="Bachelor's Degree"
                                                variant="outlined"
                                                hint="Please add ( , ) if you have multiple degrees."
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                rows="2"
                                                >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-textarea
                                                v-model="graduate"
                                                label="Master's Degree"
                                                variant="outlined"
                                                hint="Please add ( , ) if you have multiple degrees, Leave blank if no applicable"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                rows="2"
                                                >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-textarea
                                                v-model="post_graduate"
                                                label="Doctoral/Professional Degree"
                                                variant="outlined"
                                                hint="Please add ( , ) if you have multiple degrees, Leave blank if no applicable"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                rows="2"
                                                >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="designation"
                                                label="Designation for Document Signatory"
                                                variant="outlined"
                                                hint="Ex: Dean, Institute of Computing (Only applicable if having SO number admin load)"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" class="mx-2">
                                            <div class="font-weight-bold">Please update your core time and consultation time for every new active semester for updated workload</div>
                                            <v-divider class="my-2"></v-divider>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="core_time"
                                                label="Core Time"
                                                variant="outlined"
                                                hint="Ex: MW 8:00-5:00, TTH 7:30-5:30, F 8:00-3:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="consultation_time"
                                                label="Consultation Time"
                                                variant="outlined"
                                                hint="Ex: MF 10:30-12:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card title="Academic Information" elevation="4">
                                <v-card-text>
                                    <v-divider></v-divider>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="employmentStatusId"
                                                label="Employment Status"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="employmentStatusData"
                                                item-title="description"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="academicRankId"
                                                label="Academic Rank"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="academicRankData"
                                                item-title="description"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="programId"
                                                label="Program"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="programData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="officeId"
                                                label="Office"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="officeData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-autocomplete
                                                v-model="positionId"
                                                label="Position"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="positionData"
                                                item-title="name"
                                                item-value="id"
                                                clearable
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            fname: null,
            mname: null,
            lname: null,
            suffix: null,
            post_nominal: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            employmentStatusId: null,
            academicRankId: null,
            officeId: null,
            programId: null,
            positionId: null,
            designation: null,
            core_time: null,
            consultation_time: null,

            employmentStatusData: [],
            academicRankData: [],
            officeData: [],
            programData: [],
            positionData: [],

            newFormRules: {

            },
        }
     },
     methods: {
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Update Basic Info'
            this.dialog_sub_title = 'Edit your basic and academic details'
            this.action = 'edit'

            this.id = data.id
            this.fname = data.fname
            this.lname = data.lname
            this.mname = data.mname
            this.suffix = data.suffix
            this.post_nominal = data.post_nominal
            this.undergraduate = data.undergraduate
            this.graduate = data.graduate
            this.post_graduate = data.post_graduate
            this.employmentStatusId = data.employmentStatusId
            this.academicRankId = data.academicRankId
            this.programId = data.programId
            this.officeId = data.officeId
            this.positionId = data.positionId
            this.designation = data.designation
            this.core_time = data.core_time
            this.consultation_time = data.consultation_time

            this.initForm()
        },
        async initForm(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/employment-status')
            .then(res => {
                this.employmentStatusData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/academic-rank')
            .then(res => {
                this.academicRankData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllOffices')
            .then(res => {
                this.officeData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/position')
            .then(res => {
                this.positionData = res.data
            });
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                let formData = {
                    id: this.id,
                    fname: this.fname,
                    mname: this.mname,
                    lname: this.lname,
                    suffix: this.suffix,
                    post_nominal: this.post_nominal,
                    undergraduate: this.undergraduate,
                    graduate: this.graduate,
                    post_graduate: this.post_graduate,
                    employmentStatusId: this.employmentStatusId,
                    academicRankId: this.academicRankId,
                    officeId: this.officeId,
                    programId: this.programId,
                    positionId: this.positionId,
                    designation: this.designation,
                    core_time: this.core_time,
                    consultation_time: this.consultation_time
                }

                const token = localStorage.getItem('aums-token')

                if(this.action == 'edit'){
                    axios.post(process.env.VUE_APP_SERVER_URL + '/user-details/userUpdateBasicInfo', formData,
                    { headers:
                        { 
                            'Authorization': `Bearer ${token}`,
                        }
                    }
                    ).then((res)=>{
                        if(res.data.status == 200){
                            this.loading = false
                            this.$emit('refresh', res.data.data)
                            showSnackbar('Basic Info successfully updated!')
                            this.$refs.form.reset()
                            this.dialog = false
                        }
                    }).catch((error)=>{
                        if(error.response.status == 401){
                            this.loading = false
                            showSnackbar('Token expired! Logging out..')

                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                        }
                        else{
                            console.log(error)
                        }
                    })
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>